import { render, staticRenderFns } from "./ReviewResult.vue?vue&type=template&id=06ad71a0&scoped=true&lang=pug&"
import script from "./ReviewResult.vue?vue&type=script&lang=ts&"
export * from "./ReviewResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ad71a0",
  null
  
)

export default component.exports